import React, { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';
import { useAuthContext } from '../../../../contexts/authContext';

type Props = {
    label: string;
    name: string;
    data?: any[];
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: any;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: React.ReactNode;
    disabled?: false | boolean;
    onChangeValue: (event: string) => void;
    reasonEnabled?: false | boolean;
    onReason?: any;
    dominantColor?: string;
};

const MultipleAutocompleteField = ({
    label,
    name,
    data,
    size,
    margin,
    required,
    value,
    touched,
    errors,
    disabled,
    onChangeValue,
    reasonEnabled,
    onReason,
    dominantColor,
}: Props) => {
    //onChangeValue Formik
    //The variable MultipleAtocompleteFormik must be equal to the variable name of the formik
    //onChangeValue={(value) => formik.setFieldValue('MultipleAtocompleteFormik', value)}

    const { modeTheme } = useAuthContext();
    const [valuesItem, setValuesItems] = useState<any[]>(value);
    const color =
        dominantColor ||
        (modeTheme === 'darkMode' ? 'primary.contrastText' : '#36c');
    return (
        <>
            <Autocomplete
                multiple={true}
                id="tags-outlined"
                options={data || []}
                disabled={disabled}
                value={valuesItem}
                onChange={(event: any, newValue: any | null) => {
                    setValuesItems(newValue || []);
                    onChangeValue(newValue || []);
                }}
                onInputChange={(_: any, e: string | null, reason) => {
                    if (reasonEnabled) {
                        onReason(reason);
                    }
                }}
                getOptionLabel={(option) => option.name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        name={name}
                        size={size}
                        margin={margin}
                        required={required}
                        helperText={touched ? errors : ''}
                        error={touched && Boolean(errors)}
                        sx={{
                            '& label.Mui-focused': {
                                color: color,
                            },
                            '& .MuiInput-underline:after': {
                                borderBottomColor: color,
                            },
                            '& .MuiFilledInput-underline:after': {
                                borderBottomColor: color,
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: color,
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: color,
                                },
                            },
                        }}
                    />
                )}
            />
        </>
    );
};

export default MultipleAutocompleteField;
